import React from "react";
import {
  BlockStack,
  Box,
  InlineStack,
  Layout,
  LegacyCard as Card,
  SkeletonBodyText,
  SkeletonDisplayText,
} from "@shopify/polaris";

const STAT_CARD_COUNT = 5;
const TABLE_ROW_COUNT = 7;

const DashboardSkeleton = () => (
  <Layout.Section>
    <div className="operator-dashboard-skeleton">
      <BlockStack gap="500">
        <Box
          background="bg-surface-secondary"
          borderColor="border"
          borderWidth="025"
          borderRadius="300"
          padding="300"
        >
          <SkeletonBodyText lines={1} />
        </Box>

        <InlineStack align="space-between" blockAlign="center" wrap={false}>
          <InlineStack gap="300" blockAlign="center">
            <Box maxWidth="220px">
              <SkeletonDisplayText size="medium" />
            </Box>
            <Box minWidth="64px" maxWidth="64px">
              <SkeletonBodyText lines={1} />
            </Box>
          </InlineStack>
          <Box minWidth="128px" maxWidth="128px">
            <SkeletonDisplayText size="small" />
          </Box>
        </InlineStack>

        <div className="operator-dashboard-stats-row">
          {Array.from({ length: STAT_CARD_COUNT }, (_, index) => (
            <div key={`stat-skeleton-${index}`} className="operator-dashboard-skeleton-stat-card">
              <SkeletonBodyText lines={1} />
              <Box paddingBlockStart="200">
                <SkeletonDisplayText size="small" />
              </Box>
              <Box paddingBlockStart="200" maxWidth="72px">
                <SkeletonBodyText lines={1} />
              </Box>
            </div>
          ))}
        </div>

        <Card>
          <Box padding="400">
            <InlineStack align="space-between" blockAlign="center" wrap={false}>
              <Box maxWidth="200px">
                <SkeletonDisplayText size="small" />
              </Box>
              <InlineStack gap="300" blockAlign="center">
                <Box minWidth="88px" maxWidth="88px">
                  <SkeletonBodyText lines={1} />
                </Box>
                <Box minWidth="140px" maxWidth="140px">
                  <SkeletonBodyText lines={1} />
                </Box>
              </InlineStack>
            </InlineStack>

            <Box paddingBlockStart="500">
              <div className="operator-dashboard-skeleton-table">
                <div className="operator-dashboard-skeleton-table__head">
                  {Array.from({ length: 6 }, (_, index) => (
                    <div key={`head-${index}`} className="operator-dashboard-skeleton-table__cell">
                      <SkeletonBodyText lines={1} />
                    </div>
                  ))}
                </div>
                {Array.from({ length: TABLE_ROW_COUNT }, (_, rowIndex) => (
                  <div key={`row-${rowIndex}`} className="operator-dashboard-skeleton-table__row">
                    {Array.from({ length: 6 }, (_, cellIndex) => (
                      <div key={`cell-${rowIndex}-${cellIndex}`} className="operator-dashboard-skeleton-table__cell">
                        <SkeletonBodyText lines={1} />
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </Box>
          </Box>
        </Card>
      </BlockStack>
    </div>
  </Layout.Section>
);

export default DashboardSkeleton;
